export const menueEentMap = {
  1346: 'Button_Click_Home',
  1347: 'Button_Click_Travel_Booking',
  1399: 'Button_Click_TRAVEL_PLAN',
  1413: 'Button_Click_CONTROL_CENTER',
  1350: 'Button_Click_SETTING_CENTER',
  'Order': 'Button_Click_Order',
  'Approve': 'Button_Click_Approve',
  1420: 'Button_Click_Travel_Plan_Query',
  1546: 'Button_Click_Travel_Order_Query',
  1422: 'Button_Click_Staff_Illegal_Record_Query',
  1836: 'Button_Click_Customer_Complaints_Query',
  1685: 'Button_Click_Auth_Record_Query',
  1416: 'Button_Click_User_Travel_Query',
  1724: 'Button_Click_Staff_Travel_Itinerary_Query',
  1866: 'Button_Click_Staff_Travel_Detail_Query',
  1475: 'Button_Click_Expense_Query',
  1873: 'Button_Click_Travel_Subsidy_Query',
  1377: 'Button_Click_Bi_Pay',
  1373: 'Button_Click_Bi_Reduce',
  1714: 'Button_Click_Bi_Staff_Reduce',
  1494: 'Button_Click_Bi_Staff_Illegal',
  1842: 'Button_Click_Bi_Travel_Report',
  1870: 'Button_Click_Bi_Agreement_Voyage',
  1867: 'Button_Click_Bi_Supplier'
}
